import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayGetTransactionsExportModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-export.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useExportTransactionListContext } from '../../transaction.context';
import { TransactionListExportFormStep1Controller } from '../transaction-list-export-form-step-1/transaction-list-export-form-step-1.controller';

export interface TransactionListExportFormControllerProps {
  onError: SubmitErrorHandler<GatewayGetTransactionsExportModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GatewayGetTransactionsExportModel>;
  onCancel: () => void;
}

export const TransactionListExportFormController = (
  props: TransactionListExportFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useExportTransactionListContext();

  return (
    <MultiStepFormProvider<GatewayGetTransactionsExportModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['createdAfter', 'createdBefore'],
          component: <TransactionListExportFormStep1Controller />,
        },
      ]}
    />
  );
};
